<p>verify-list-documents works!</p>
